import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import Logos from "../Sections/home/Logos";
import { Link, useNavigate, useParams } from "react-router-dom";
import { useGetPostQuery } from "../Redux/Apis/blogApi";
import Loading from "../Layouts/Loading";
import { fa_date, fa_number } from "../utils/Persian";
import PostSidebar from "../Sections/blog/PostSidebar";
import MetaTags from "../Components/MetaTags";
import { useEffect } from "react";
import { safeParseHtml } from "../utils/safeParseHtml";

function Post() {
    let { id ,name } = useParams();
    const navigate = useNavigate()
    if(id === undefined ) navigate(`/blog`)
    const postID = id ? parseInt(id) : 0;

    const {data , isSuccess, isLoading} = useGetPostQuery(+postID)

    useEffect(() => {
        if (data && data.post.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase() !== name) {
          navigate(`/post/${postID}/${data.post.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`, { replace: true });
        }
    }, [data, postID, name, navigate]);

    return ( 
        <>
        {isLoading && <Loading />}
        {isSuccess && data && data.post &&
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title={data.post.title + " | سایت مرجع آزمون GRE"}
            description={data.post.excerpt ? data.post.excerpt : ''}
            url={`https://grehub.org/post/${postID}/${data.post.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`}
            image={"https://grehub.org" + data.post.image}
            keywords={data.post.tags ? data.post.tags : ''}
            ogType="article"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid bg-danger py-2 bg-header" style={{marginBottom: "90px"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">{data.post.title}</h1>
                    <Link to="/" className="h5 text-white">خانه</Link>
                    <FontAwesomeIcon icon={faCircle} className="text-white px-2"/>
                    <Link to="/blog" className="h5 text-white">وبلاگ</Link>
                    <FontAwesomeIcon icon={faCircle} className="text-white px-2"/>
                    <Link to="" className="h5 text-white">{data.post.title}</Link>
                </div>
            </div>
        </div>

        <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-8 mb-5">
                        <div className="mb-5">
                            <img className="img-fluid w-100 rounded mb-5" src={data.post.image} alt={data.post.title}/>
                            <h1>{data.post.title}</h1>
                            <div className="d-flex mb-4">
                                <small className="me-3"><FontAwesomeIcon icon="user" className="text-danger me-2"/>{data.post.BlogCategory.name}</small>
                                <small className="me-3"><FontAwesomeIcon icon="calendar-alt" className="text-danger me-2"/>{fa_date(data.post.create_date)}</small>
                                <small><FontAwesomeIcon icon="eye" className="text-danger me-2"/>{fa_number(data.post.views)}</small>
                            </div>
                            {data.post.body && <div>{safeParseHtml(data.post.body)}</div>}
                        </div>
                    </div>

                    {(data.post.NextPost || data.post.PrePost) && <div className="col-12 mb-5 border-top border-bottom border-2 p-0 text-center d-block d-lg-none">
                        <h5 className="mt-4 mb-1 text-danger">« بیشتر بخوانید »</h5>
                        <div className="row pb-5">
                            <div className="col-6 text-start">
                                {data.post.PrePost && 
                                <>
                                    <p className="text-secondary mb-1 text-opacity-75"><FontAwesomeIcon className="me-1 align-middle" icon="arrow-right"/>پست‌قبلی</p>
                                    <Link to={`/post/${data.post.PrePost.id}/${data.post.PrePost.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="d-flex rounded overflow-hidden text-dark">
                                        <img className="img-fluid" src={data.post.PrePost.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={data.post.PrePost.title}/>
                                        <div className="h5 fw-semi-bold d-flex align-items-center bg-light px-3 mb-0" style={{minWidth:"80%"}}>{data.post.PrePost.title}</div>
                                    </Link>
                                </>}
                            </div>
                            <div className="col-6 text-end">
                                {data.post.NextPost && 
                                <>
                                    <p className="text-secondary mb-1 text-opacity-75">پست‌بعدی<FontAwesomeIcon className="ms-1 align-middle" icon="arrow-left"/></p>
                                    <Link to={`/post/${data.post.NextPost.id}/${data.post.NextPost.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="d-flex rounded overflow-hidden text-dark">
                                        <div className="h5 fw-semi-bold d-flex justify-content-end align-items-center bg-light px-3 mb-0" style={{minWidth:"85%"}}>{data.post.NextPost.title}</div>
                                        <img className="img-fluid" src={data.post.NextPost.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={data.post.NextPost.title}/>
                                    </Link>
                                </>}
                            </div>
                        </div> 
                    </div>}

                    <PostSidebar last_posts={data.last_posts} categories={data.categories}/>
                    
                    {(data.post.NextPost || data.post.PrePost) && <div className="col-12 mb-5 border-top border-bottom border-2 p-0 text-center d-none d-lg-block">
                        <h5 className="mt-4 mb-1 text-danger">« بیشتر بخوانید »</h5>
                        <div className="row pb-5">
                            <div className="col-6 text-start">
                                {data.post.PrePost && 
                                <>
                                    <p className="text-secondary mb-1 text-opacity-75"><FontAwesomeIcon className="me-1 align-middle" icon="arrow-right"/>پست‌قبلی</p>
                                    <Link to={`/post/${data.post.PrePost.id}/${data.post.PrePost.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="d-flex rounded overflow-hidden text-dark">
                                        <img className="img-fluid" src={data.post.PrePost.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={data.post.PrePost.title}/>
                                        <div className="h5 fw-semi-bold d-flex align-items-center bg-light px-3 mb-0" style={{minWidth:"80%"}}>{data.post.PrePost.title}</div>
                                    </Link>
                                </>}
                            </div>
                            <div className="col-6 text-end">
                                {data.post.NextPost && 
                                <>
                                    <p className="text-secondary mb-1 text-opacity-75">پست‌بعدی<FontAwesomeIcon className="ms-1 align-middle" icon="arrow-left"/></p>
                                    <Link to={`/post/${data.post.NextPost.id}/${data.post.NextPost.title.replace(/[ &/\\#,+$~%.'":*<>{}]/g, '-').replace(/\?/g, '').toLowerCase()}`} className="d-flex rounded overflow-hidden text-dark">
                                        <div className="h5 fw-semi-bold d-flex justify-content-end align-items-center bg-light px-3 mb-0" style={{minWidth:"85%"}}>{data.post.NextPost.title}</div>
                                        <img className="img-fluid" src={data.post.NextPost.image} style={{width: "100px", height: "100px", objectFit: "cover"}} alt={data.post.NextPost.title}/>
                                    </Link>
                                </>}
                            </div>
                        </div> 
                    </div>}

                    <Logos />
                </div>
            </div>
        </div>
        </>}
        
        </>
     );
}

export default Post;
